import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Wizard } from '../../../../../src/web/components';
import { AmenitiesSelector, AmenityCustomization } from '.';

const propTypes = {
  facility: PropTypes.shape({
    amenities: PropTypes.arrayOf(PropTypes.object({
      name: PropTypes.string,
      desription: PropTypes.string,
    })),
  }).isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  amenities: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object({
    name: PropTypes.string,
    desription: PropTypes.string,
  }))),
  title: PropTypes.string,
  isSubmitting: PropTypes.bool,
};

const defaultProps = {
  amenities: [],
  title: '',
  isSubmitting: undefined,
};

class Editor extends React.Component {
  steps = [
    {
      name: 'Select Amenities',
      value: 'selectAmenities',
      component: AmenitiesSelector,
    },
    {
      name: 'Customize',
      value: 'customize',
      component: AmenityCustomization,
    },
  ];

  constructor(props) {
    super(props);

    this.state = {
      currentStep: 'selectAmenities',
      show: true,
      amenities: [],
      title: '',
    };
  }

  componentDidMount = () => {
    const { amenities, facility: { amenities: facilityAmenities }, title } = this.props;

    let prevAmenities = amenities;
    let newTitle = title;

    if (!amenities.length) {
      prevAmenities = facilityAmenities.filter(amenity => amenity.enabled);
      prevAmenities = prevAmenities.map(amenity => ({ name: amenity.name, description: '' }));
    }

    if (title === '') {
      newTitle = 'Facility Amenities';
    }
    this.setState({ amenities: prevAmenities, title: newTitle });
  }

  onSelectStep = currentStep => this.setState({ currentStep });

  handleSave = () => {
    const { onFinishEdit, facility: { id: facilityId } } = this.props;
    const { amenities, title } = this.state;
    onFinishEdit({ facilityId, amenities, title });
  }

  updateAmenities = (amenities) => {
    const { amenities: currentAmenities } = this.state;
    const newAmenities = amenities.map((amenity) => {
      const currAmenity = currentAmenities.find(curr => curr.name === amenity.name);
      return { ...amenity, description: currAmenity ? currAmenity.description : '' };
    });
    this.setState({ amenities: newAmenities });
  }

  updateAmenityCustomization = (amenities) => {
    this.setState({ amenities });
  }

  updateTitle = title => this.setState({ title });

  disableNextBtn = nextBtnDisabled => this.setState({ nextBtnDisabled });


  render() {
    const {
      currentStep,
      show,
      nextBtnDisabled,
      amenities,
      title,
    } = this.state;

    const { onCancelEdit, facility, isSubmitting } = this.props;

    const stepProps = {
      title,
      facility,
      amenities,
      disableNextBtn: this.disableNextBtn,
      updateAmenities: this.updateAmenities,
      updateTitle: this.updateTitle,
      updateAmenityCustomization: this.updateAmenityCustomization,
    };

    const thisStep = this.steps.find(step => step.value === currentStep);
    const StepComponent = thisStep.component;

    const wizardProps = {
      title: 'Facility Amenities Editor',
      currentStep,
      stepComponent: <StepComponent {...stepProps} />,
      steps: this.steps,
      show,
      modalSize: 'md',
      onClose: onCancelEdit,
      nextBtnDisabled,
      futureStepsDisabled: true,
      onSelectStep: this.onSelectStep,
      onSave: this.handleSave,
      isSubmitting,
    };

    return (
      <div>
        <Wizard {...wizardProps} />
      </div>
    );
  }
}

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

Editor.fragments = {
  facility: gql`
    fragment EditorFacility on Facility {
      amenities {
        name
        description
        enabled
      }
    }
  `,
};

export default Editor;
